import React, { useEffect, useState } from "react";
import { FaExclamationTriangle, FaPencilAlt } from "react-icons/fa";
import { toast } from "react-toastify";

function parseHoursInput(raw) {
  const normalized = String(raw || "")
    .trim()
    .replace(/\./g, "")
    .replace(",", ".");
  if (!normalized) return null;
  const value = Number.parseFloat(normalized);
  if (Number.isNaN(value) || value < 0) return null;
  return value;
}

function formatEditableValue(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 1 });
}

export default function FieldAppMaintenanceEditableHours({
  value,
  field,
  recordUuid,
  maintenanceId,
  t,
  onSave,
  overdue = false,
  disabled = false,
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!editing) {
      setDraft(value != null ? String(value) : "");
    }
  }, [value, editing]);

  const beginEdit = () => {
    if (disabled) return;
    setDraft(value != null ? String(value) : "");
    setEditing(true);
  };

  const cancelEdit = () => {
    setEditing(false);
    setDraft(value != null ? String(value) : "");
  };

  const submitEdit = async () => {
    const parsed = parseHoursInput(draft);
    if (parsed == null) {
      toast.error(t("Informe um valor numérico válido (horas)."));
      return;
    }

    setSaving(true);
    try {
      await onSave({
        recordUuid,
        maintenanceId,
        field,
        value: parsed,
      });
      setEditing(false);
      toast.success(t("Manutenção atualizada."));
    } catch (error) {
      toast.error(t("Não foi possível salvar a alteração."));
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <div className="field-app-maintenance-editable-editor">
        <input
          type="text"
          inputMode="decimal"
          className="form-control input-sm field-app-maintenance-editable-input"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          disabled={saving}
          autoFocus
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              submitEdit();
            }
            if (event.key === "Escape") {
              event.preventDefault();
              cancelEdit();
            }
          }}
        />
        <button
          type="button"
          className="btn btn-xs btn-primary"
          onClick={submitEdit}
          disabled={saving}
        >
          {saving ? "…" : t("Salvar")}
        </button>
        <button
          type="button"
          className="btn btn-xs btn-default"
          onClick={cancelEdit}
          disabled={saving}
        >
          {t("Cancelar")}
        </button>
      </div>
    );
  }

  const formatted = formatEditableValue(value);

  return (
    <button
      type="button"
      className={`field-app-maintenance-editable${
        overdue ? " field-app-maintenance-overdue field-app-maintenance-overdue--emphasis" : ""
      }`}
      onClick={beginEdit}
      disabled={disabled}
      title={
        overdue
          ? t("Manutenção vencida — clique para corrigir o horímetro-alvo")
          : t("Clique para corrigir o valor informado pelo operador")
      }
    >
      {overdue ? (
        <>
          <FaExclamationTriangle aria-hidden className="field-app-maintenance-overdue-icon" />
          <span className="field-app-maintenance-overdue-value">{formatted} h</span>
          <span className="field-app-maintenance-overdue-label">{t("Vencida")}</span>
        </>
      ) : (
        <>
          <span>{formatted}</span>
          {!disabled ? (
            <FaPencilAlt aria-hidden className="field-app-maintenance-editable-icon" />
          ) : null}
        </>
      )}
    </button>
  );
}
